module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/BankAccountTxTypes.ejs -->\n<div class="form-group">\n    <label class="col-sm-4 control-label">\n        Payment/Transaction Type\n        <i class="fa fa-question-circle"\n            data-toggle="tooltip"\n            data-placement="top"\n            data-container="body"\n            title="Select the payment mode/transaction type to be used when\n                issuing files for bulk payments"></i>\n    </label>\n    <div class="col-sm-8">\n        <select name="transactionType" class="form-control">\n            <option value="" disabled\n                    '+
((__t=( !transactionType ?
                        'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Please select one\n            </option>\n            ';
 _.each(txTypes, function(tx, i) { 
__p+='\n                <option value="'+
((__t=( tx.type ))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( transactionType == tx.type ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( tx.desc ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n        <span class="error error-transactionType"></span>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/BankAccountTxTypes.ejs
// module id = 785
// module chunks = 1